var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42882 18.2857V17.7141C7.42882 15.8206 8.96384 14.2857 10.8574 14.2857H13.1431C15.0366 14.2857 16.5717 15.8206 16.5717 17.7141V18.2857M12.0002 7.42857C10.7379 7.42857 9.71453 8.45192 9.71453 9.71429C9.71453 10.9767 10.7379 12 12.0002 12C13.2626 12 14.286 10.9767 14.286 9.71429C14.286 8.45192 13.2626 7.42857 12.0002 7.42857ZM12.0002 20C7.58197 20 4.00024 16.4183 4.00024 12C4.00024 7.58172 7.58197 4 12.0002 4C16.4185 4 20.0002 7.58172 20.0002 12C20.0002 16.4183 16.4185 20 12.0002 20Z",
    stroke: "currentColor",
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.7a21de27d0426dd7a753b023fe1f20ff.svg";
export { ForwardRef as ReactComponent };